export const managerMessages = {
    defaultTextArrow: 'Untitled hotspot text',
    defaultTitleBlindTest: 'Untitled hidden area',
    defaultTitleChoice: 'Option',
    defaultTitleChoiceOptional: 'Enter text...',
    defaultTitleHotspot: 'Untitled hotspot',
    defaultTitleMultipleChoice: 'Question',
    defaultTitleNonSequencedContent: 'Untitled hotspot map',
    defaultTitleQuestion: 'Untitled question',
    defaultTitleSection: 'Untitled section',
    defaultTitleSequencedContent: 'Untitled linear flow',
    defaultTitleStep: 'Untitled step',
    defaultTitleStartMessage: 'Untitled start message',
    defaultTitleSubmenu: 'Untitled submenu',
    defaultTitleTabs: 'Untitled tab',
    defaultTitleTest: 'Untitled test',
    defaultQuestionWidgetText: 'Question goes here',
    defaultSortationWidgetText: 'Add your sorting question here',
    defaultTitleResources: 'Resources',
    defaultTitleResource: 'Resource',
    defaultPlaceholderTitle: 'Add title here...',
    defaultPlaceholderQuestion: 'Add question here...',
};
